import * as React from "react";

export class RenewalChangesBanner extends React.Component<{}, {}> {

    public render() {
        return <div className="banner-text banner-warn p-4 mb-3">
                <div className="banner-text">
                    <p className="font-weight-bold">Have you already made changes to your renewal?</p>
                    <div className="mb-2">
                        <p>If you make a change to your current policy that starts <strong>before your renewal date</strong>,
                            any changes you made to your renewal will be removed.</p>
                    </div>
                    <p>This includes:</p>
                    <ul>
                        <li>Cover or personal details</li>
                        <li>Payment method changes</li>
                    </ul>
                    <p>Changes that apply before your renewal will carry over into next year, so it's fine to make these first. Just remember to go back into your renewal and reapply any other changes you need.</p>
                </div>
            </div>
        }
    }
